import React, { useEffect, useState } from "react";
import "./Services.css";
import srvc1 from '../../images/services/srvc1.png';
import srvc2 from '../../images/services/srvc2.png';
import srvc3 from '../../images/services/srvc3.png';
import shpe from '../../images/services/shpe.png';
import whitshp from '../../images/services/whitshp.png';
import srvcpic1 from '../../images/services/srvcpic1.jpg';
import srvcimg1 from '../../images/services/srvcimg1.jpg';
import srvcimg2 from '../../images/services/srvcimg2.jpg';
import srvcimg3 from '../../images/services/srvcimg3.jpg';

export default function Services() {
  const [solutionsData, setSolutionsData] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/home-page`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-username": `${process.env.REACT_APP_API_URL_USERNAME}`,
        "api-password": `${process.env.REACT_APP_API_URL_PASSWORD}`
      },
      body: JSON.stringify({})
    })
      .then((response) => response.json())
      .then((data) => {
        setSolutionsData(data.home_page_solutions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  return (
    <section className="services-section" id="services">
      <div className="container">

        {/* HEADER */}
        <div className="svc-header text-center">
          <span className="svc-tag">Solutions</span>
          <h2 className="svc-heading">Core Capabilities</h2>
          <p className="svc-subheading">
            Integrated expertise. Scalable solutions. Real business impact.
          </p>
        </div>

        {/* CARDS */}
        <div className="svc-row">
          <div className="svc-col">
            <div className="svc-card svc-theme-one">
              <div className="svc-top-band">
                <img src={srvcimg1} alt="" className="svc-top-img" />
              </div>

              {/* ICON */}
              <div className="svc-icon">
                <img src={srvc1} alt={solutionsData.title_1} />
              </div>

              {/* CONTENT */}
              <h3>{solutionsData.title_1}</h3>
              <p>{solutionsData.description_1}</p>

              <a href="#services" className="svc-link" aria-label={`Explore more about ${solutionsData.title_1}`}>
                Explore More <span aria-hidden="true">&#8594;</span>
              </a>

              <div className="svc-bottom-band">
                <img src={srvcimg1} alt="" className="svc-bottom-img" />
                <div className="svc-bottom-grid" />
              </div>
            </div>
          </div>
          <div className="svc-col">
            <div className="svc-card svc-theme-one">
              <div className="svc-top-band">
                <img src={srvcimg2} alt="" className="svc-top-img" />
              </div>

              {/* ICON */}
              <div className="svc-icon">
                <img src={srvc2} alt={solutionsData.title_2} />
              </div>

              {/* CONTENT */}
              <h3>{solutionsData.title_2}</h3>
              <p>{solutionsData.description_2}</p>

              <a href="#services" className="svc-link" aria-label={`Explore more about ${solutionsData.title_2}`}>
                Explore More <span aria-hidden="true">&#8594;</span>
              </a>

              <div className="svc-bottom-band">
                <img src={srvcimg2} alt="" className="svc-bottom-img" />
                <div className="svc-bottom-grid" />
              </div>
            </div>
          </div>
          <div className="svc-col">
            <div className="svc-card svc-theme-one">
              <div className="svc-top-band">
                <img src={srvcimg3} alt="" className="svc-top-img" />
              </div>

              {/* ICON */}
              <div className="svc-icon">
                <img src={srvc3} alt={solutionsData.title_3} />
              </div>

              {/* CONTENT */}
              <h3>{solutionsData.title_3}</h3>
              <p>{solutionsData.description_3}</p>

              <a href="#services" className="svc-link" aria-label={`Explore more about ${solutionsData.title_3}`}>
                Explore More <span aria-hidden="true">&#8594;</span>
              </a>

              <div className="svc-bottom-band">
                <img src={srvcimg3} alt="" className="svc-bottom-img" />
                <div className="svc-bottom-grid" />
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}